<!-- bonus.wxml -->
<template>
    <div class="address-box">
        <div class="address-list-box">
            <div class="address-item" v-for="(item,index) in shopList" :key="index">
                <div class="address" @click="onSelectedShop(item.shop_name,item.shop_id)">
                    <div class="name" style="color: #ff5656">{{item.shop_name}}</div>
                    <div class="dateil" style="color: #777;font-size: 12px;">地址：{{ item.region.province }}{{
                        item.region.city }}{{ item.region.region }}{{ item.address }}
                    </div>
                    <div class="dateil" style="color: #777;font-size: 12px">联系电话：{{ item.phone }}</div>
                    <div class="dateil" v-if="item.distance" style="color: #aaa;font-size: 12px;margin-top: 5px;">距离：{{
                        item.distance_unit }}
                    </div>
                </div>
            </div>
            <!-- no-result -->
            <div class="noresult" v-if="!shopList.length">
                <div class="cot">
                    <div class="img">
                        <img src="../../assets/images/no_result.png">
                    </div>
                    <p class="text" style="color: #aaa;">暂无门店信息</p>
                </div>
            </div>
            <!-- no-result end -->
        </div>
    </div>
</template>
<script>
    import Tabber from '@/components/Tabber.vue'

    export default {
        name: 'MemberAddress',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                selectedId: -1,
                isAuthor: true,
                shopList: [], // 门店列表
                showAdd: false, //添加地址
                defaultAddress: '',
                memberAddress: [],
                default_id: 0, // 默认地址 id
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading..', {
                coverColor: "rgba(0,0,0,0.5)",
            });

        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.selectedId = _this.$route.query.selectedId;
            // 获取默认门店列表
            _this.getShopList();
            // 获取用户坐标
            _this.getLocation((res) => {
                _this.getShopList(res.longitude, res.latitude);
            });

        },
        methods: {

            /**
             * 获取门店列表
             */
            getShopList(longitude, latitude) {
                let _this = this;
                _this._get('shop/lists', {
                    longitude: longitude || '',
                    latitude: latitude || ''
                }, (result) => {
                    _this.loading.hide();
                    _this.setData({
                        shopList: result.data.list,
                    });
                });
            },

            /**
             * 选择门店
             */
            onSelectedShop(name, selectedId) {
                let _this = this;
                // 设置选中的id
                _this.$ls.set('checkZip', 1);
                _this.selectedId = selectedId;
                _this.$ls.set('shippingLocation',name);
                _this.$ls.set('shippingLocation_id',selectedId);
                // 返回上级页面
                _this.$router.go(-1);
            },

            /**
             * 获取用户坐标
             */
            getLocation(callback) {
                let _this = this;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        //locationSuccess 获取成功的话
                        function (position) {
                            callback && callback(position.coords)
                        },
                        //locationError  获取失败的话
                        function (error) {
                            var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时'];
                            // _this.$toast.fail(errorType[error.code - 1]);
                            _this.isAuthor = false;
                        }
                    );
                }
            },


        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss" scoped>
    @import "index";
</style>
